import React from "react";
import { LegacyCard, TextField, InlineGrid, Button, Spinner } from "@shopify/polaris";

const ShirtMeasurements = ({ values, errors, onChange, message, loading, onSave, dataType }) => {
  const shortSleeveOnlyKeys = ["shirtSleeveLenghtL", "shirtSleeveLenghtR", "shortSleeveCuff"];
  const longSleeveOnlyKeys = ["sleeveL", "sleeveR", "cuffL", "cuffR"];
  const allFields = [
    { label: "Neck", key: "neck" },
    { label: "Chest", key: "chest" },
    { label: "Stomach", key: "stomach" },
    { label: "Shirt Hip", key: "shirttHip" },
    { label: "Shoulder", key: "shoulder" },
    { label: "Shirt Length", key: "shirtLength" },
    { label: "Sleeve (L)", key: "sleeveL" },
    { label: "Sleeve (R)", key: "sleeveR" },
    { label: "Cuff (L)", key: "cuffL" },
    { label: "Cuff (R)", key: "cuffR" },
    { label: "Short Sleeve Length (L)", key: "shirtSleeveLenghtL" },
    { label: "Short Sleeve Length (R)", key: "shirtSleeveLenghtR" },
    { label: "Short Sleeve Cuff", key: "shortSleeveCuff" },
  ];
  let fields = allFields;
  if (dataType === "Men Shirt Long Sleeve") {
    fields = allFields.filter((f) => !shortSleeveOnlyKeys.includes(f.key));
  } else if (dataType === "Men Shirt Short Sleeve" || dataType === "T-Shirt & Polo") {
    fields = allFields.filter((f) => !longSleeveOnlyKeys.includes(f.key));
  }

  return (
    <LegacyCard title="Shirt Measurements" sectioned>
      <InlineGrid columns={{ xs: 2, sm: 2, md: 2, lg: 3 }} gap="400">
        {fields.map(({ label, key }) => (
          <TextField
            key={key}
            label={label}
            value={values[key]}
            onChange={(value) => onChange(key)(value)}
            error={errors?.[key]}
          />
        ))}
      </InlineGrid>
      {message && (
        <p className="sucess_mess order_customer_mess">{message}</p>
      )}
      {onSave && (
        <div className="customerAddBtn order_cus_btn">
          {!loading ? (
            <Button variant="primary" onClick={onSave}>
              Save
            </Button>
          ) : (
            <Spinner accessibilityLabel="Saving measurements" size="small" />
          )}
        </div>
      )}
    </LegacyCard>
  );
};

export default ShirtMeasurements;